import React from "react"
import Image from "next/image"

export default function ArticleImage(props: { url: string, altText: string, caption?: any}) {
  return (
    <div className="article-image mb-2">
      <Image src={props.url} width={0} height={0} alt={props.altText} sizes="100vw" style={{ width: 'inherit', height: 'inherit' }}/>
      <div className="italic">{props.caption}</div>
    </div>
  );
}
